import './section-subscribe.component.scss'

const subForm = document.querySelector('.section-subscribe')
if (subForm) {
  const inputWrap = subForm.querySelector('.frm_form_field')
  inputWrap.style.setProperty('--bg-ico', 'url("images/contact-form__ico-mail.svg")')

  const input = subForm.querySelector('.frm_form_field [type="email"]')
  const btnWrap = subForm.querySelector('.frm_submit')

  input.after(btnWrap)
}